import styled from '@emotion/styled';
import { Paragraph2 } from 'inpock-ui-react';
import { colors } from 'inpock-ui-react/dist/src/color';

import IconStar from '@/assets/icons/icon-star.svg';

export const MarketProductWrapper = styled.div`
  cursor: pointer;
`;

export const MarketProductContainer = styled.div`
  width: 100%;
  position: relative;
  padding-bottom: 100%;
  display: flex;
  justify-content: center;

  img {
    border-radius: 8px;
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const OpenDate = styled.div`
  position: absolute;
  border-radius: 15px;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(4px);
  bottom: 10px;
  padding: 2px 8px;
`;

export const ProductReview = styled.div`
  display: flex;
  align-items: center;
  margin-top: 6px;

  .icon-star {
    width: 12px;
    height: 12px;
    background: url(${IconStar}) no-repeat;
    background-size: contain;
    display: inline-block;
    margin-right: 4px;
  }
`;

export const ProductTitle = styled(Paragraph2)`
  margin-top: 10px;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const ProductPrice = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 6px;

  .price-wrapper {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .original-price {
    text-decoration: line-through;
  }
`;

export const EndBadge = styled.div`
  display: inline-block;
  padding: 0 6px 2px;
  margin-top: 12px;
  border-radius: 5px;
  background-color: ${colors.gray400};
`;
